import type { Filter as PixiFilter } from 'pixi.js';
import { TypedParentMixin } from '../parentMixin';
import { ReactiveBase } from '../reactivity';
import { TypedSerializableMixin } from '../serializableMixin';
import { TypedUpdateFlowMixin } from '../updateFlowMixin';

export abstract class Filter extends TypedUpdateFlowMixin(
    TypedParentMixin(TypedSerializableMixin(ReactiveBase)),
) {
    abstract override _classType: string;
    declare readonly id: string;
    declare readonly name: string;
    /** @internal */
    abstract pixiFilter: PixiFilter;

    override get readonlyProperties() {
        return ['classType', 'name'];
    }

    abstract isNeutral(): boolean;

    get resolution(): number | null {
        return this.pixiFilter.resolution;
    }

    set resolution(value: number | null) {
        this.pixiFilter.resolution = value;
    }

    override destroy() {
        this.disposeReactions();
        this.pixiFilter.destroy();
    }

    /**
     * Disposes the reactions and listeners this filter registered, leaving the PIXI filter alone. A filter whose
     * PIXI filter holds a shared resource destroys itself through this instead.
     */
    protected disposeReactions() {
        super.destroy();
    }
}
